export enum DotCMSInitializationParams {
  ConfigName = 'configName',
  UrlPath = 'urlpath',
  MbcDefaultAccesspoint = 'mbcDefaultAccesspoint',
  CoreHostId = 'coreHostId',
  SiteType = 'siteType',
  HostTitle = 'hostTitle',
  FacilityCoids = 'facilityCoids',
  Program = 'program',
  Distance = 'distance',
  HostApp = 'hostApp',
  DotcmsHostId = 'dotcmsHostId',
  DotcmsHostName = 'dotcmsHostName',
}
